import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APIRouteMap } from '@core/models/api';
import { environment } from '@environment';
import { GetOperationResponseDto } from '@paypoint-frontend/paynet-spa-wallet-customer-contracts/ecomcashout';
import { map } from 'rxjs';
import {
  mapGetOperationResponseDtoToCashoutOperation,
  mapGetOperationToGetOperationRequestDto,
  mapResendEmailToResendEmailRequestDto,
} from './adapter';
import { ResendEmail } from './model';

@Injectable()
export class ApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.merchantApiBaseUrl;

  getOperation(paymentId: number, signature: string) {
    const dto = mapGetOperationToGetOperationRequestDto(paymentId, signature);
    let params = new HttpParams();

    Object.entries(dto).forEach(([key, value]) => {
      params = params.set(key, value);
    });

    return this.http
      .get<GetOperationResponseDto>(
        this.buildUrl(APIRouteMap.MERCHANT_PSPCASHOUT_OPERATIONGET),
        { params },
      )
      .pipe(map((response) => mapGetOperationResponseDtoToCashoutOperation(response)));
  }

  resendEmail(model: ResendEmail) {
    const dto = mapResendEmailToResendEmailRequestDto(model);

    return this.http.post<void>(
      this.buildUrl(APIRouteMap.MERCHANT_PSPCASHOUT_OPERATIONRESENDEMAIL),
      dto,
    );
  }

  private buildUrl(route: APIRouteMap): string {
    const normalizedRoute = route.replace(/^\/+/, '');
    const normalizedBaseUrl = this.baseUrl.replace(/\/+$/, '');

    return normalizedBaseUrl
      ? `${normalizedBaseUrl}/${normalizedRoute}`
      : `/${normalizedRoute}`;
  }
}
